import styled from 'styled-components';

export const TableStyle = styled.div`
  .table-item {
    margin-bottom: 10px;
  }
`;

export const TableTitle = styled.div`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 4px;
  position: sticky;
  left: 0;
`;
